// extracted by mini-css-extract-plugin
export default {"contentStyle":"OutOfPointsUseRemaining_contentStyle__0z8O6","container":"OutOfPointsUseRemaining_container__c2Qk-","footer":"OutOfPointsUseRemaining_footer__7qhjn"};